// Nebenhandlung als Textverweis („Stattdessen einen Wiederherstellungscode eingeben“, „Zurück“): bricht um statt
// über den Kartenrand zu laufen (Telefon ab 320 px), Trefferfläche mindestens 44 px hoch.
import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '../../lib/cn'

export interface TextActionProps {
  icon?: LucideIcon
  children: ReactNode
  onClick: () => void
  className?: string
  'data-testid'?: string
}

export function TextAction({ icon: Icon, children, onClick, className, 'data-testid': testId }: TextActionProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={cn(
        'inline-flex min-h-11 max-w-full items-center gap-1.5 rounded-xs py-1 text-left text-dense font-medium text-fg-accent underline-offset-2 hover:underline touch:text-touch',
        className,
      )}
    >
      {Icon && <Icon className="size-4 shrink-0" strokeWidth={1.75} aria-hidden />}
      <span className="min-w-0">{children}</span>
    </button>
  )
}
